import type { IInstrumentDashboardSummary } from '@brushfire/types'

export interface RespondentGenderSegment {
  key: string
  label: string
  count: number
  percent: number
}

/** Optional API extensions (forward-compatible when campaign-service adds fields). */
export interface InstrumentDashboardSummaryView extends IInstrumentDashboardSummary {
  respondentGenderSplit?: RespondentGenderSegment[]
  projectedCompletionAt?: string | null
  /** Present on Direct Instrument Builder (quick) dashboards. */
  origin?: 'campaign' | 'quick'
}

function isGenderSegment(value: unknown): value is RespondentGenderSegment {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as RespondentGenderSegment).key === 'string' &&
    typeof (value as RespondentGenderSegment).label === 'string' &&
    typeof (value as RespondentGenderSegment).count === 'number' &&
    typeof (value as RespondentGenderSegment).percent === 'number'
  )
}

/** Preserve typed summary while reading optional brownfield / future API fields. */
export function normalizeInstrumentDashboardSummary(
  data: IInstrumentDashboardSummary,
): InstrumentDashboardSummaryView {
  const raw = data as InstrumentDashboardSummaryView & Record<string, unknown>
  const split = raw.respondentGenderSplit
  const projectedCompletionAt =
    typeof raw.projectedCompletionAt === 'string' ? raw.projectedCompletionAt : null

  return {
    ...data,
    respondentGenderSplit: Array.isArray(split)
      ? split.filter(isGenderSegment)
      : undefined,
    projectedCompletionAt,
  }
}
